import styled from "styled-components"
import { Tooltip as ReactTooltip } from "react-tooltip"

export const BarContainer = styled.div<{
  $color: string
  $width: string
  $start: string
  $isLongTerm?: boolean
}>`
    position: absolute;
    top: 50%;
    left: ${props => props.$start};
    width: ${props => props.$width};
    height: 2.5rem;
    background: ${props => props.$isLongTerm
      ? `linear-gradient(90deg, #1a1a1a 0%, #1a1a1a 35%, ${props.$color} 65%, ${props.$color} 100%)`
      : props.$color};
    transform: translateY(-50%);
    z-index: 2;
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.8rem;
    border-radius: 1.5rem;
    overflow: hidden;
    box-shadow: ${props => props.$isLongTerm ? '0 0.2rem 0.6rem rgba(0, 0, 0, 0.25)' : 'none'};
    border: ${props => props.$isLongTerm ? '0.1rem solid rgba(0, 0, 0, 0.15)' : 'none'};

    &:hover {
        cursor: pointer;
        box-shadow: ${props => props.$isLongTerm
          ? '0 0.3rem 0.8rem rgba(0, 0, 0, 0.35)'
          : '0 0.2rem 0.4rem rgba(0, 0, 0, 0.15)'};
    }
`

export const RuleName = styled.span`
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledTooltip = styled(ReactTooltip)`
  background: ${p => p.theme.colors.greenDark} !important;
  border-radius: 0.4rem !important;
  padding: 1.2rem 1.6rem !important;
  font-size: 1.1rem !important;
  line-height: 2rem !important;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.15) !important;
  opacity: 1 !important;
  z-index: 3;
  transition: none !important;

  &:after {
    border-top-color: ${p => p.theme.colors.greyDark} !important;
  }
`

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const TooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 0.4rem;
`

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

    svg {
        fill: ${p => p.theme.colors.white};
        height: 1.1rem;
    }
`

export const TooltipAction = styled.div`
  margin-top: 0.8rem;
  font-size: 1.2rem;
`

export const TooltipType = styled.div`
  background: ${p => p.theme.colors.greenLight};
  padding: 0.2rem 0.6rem;
  border-radius: 0.3rem;
  font-size: 1rem;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0.4rem;
`
